import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path
      fillRule="evenodd"
      d="M19.181 1.25c-.946 0-1.854.375-2.523 1.045L14.56 4.392a.8.8 0 0 0-.17.169L3.312 15.643a2.75 2.75 0 0 0-.686 1.141v.002l-1.322 4.352v.003a1.25 1.25 0 0 0 1.557 1.555l4.355-1.32a2.75 2.75 0 0 0 1.141-.684L19.438 9.61a.8.8 0 0 0 .171-.171l2.095-2.096a3.569 3.569 0 0 0-2.523-6.092m-.188 6.682 1.65-1.65a2.07 2.07 0 0 0-2.925-2.927l-1.65 1.652zm-3.986-1.865L4.37 16.705a1.25 1.25 0 0 0-.312.518l-1.184 3.901L6.78 19.94a1.25 1.25 0 0 0 .518-.31L17.933 8.993z"
      clipRule="evenodd"
    />
  </>
);

const Edit = Icon('edit', svgContents);

export default Edit;
